import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Select } from "antd";

import * as T from "utils/types";
import { creationFilterThunks } from "./CreationFilterBlockSlice";
import searchPageUserInputS from "features/content/search_page/UserInputsSlice";

const { Option } = Select;

export default () => {
  const dispatch = useDispatch();

  const {
    searchInput,
    keywordType,
    facultyID,
    departmentID,
    creationSpecific: { year },
  } = useSelector((state: T.RootState) => state.searchPgUserInputs);

  useEffect(() => {
    dispatch(
      creationFilterThunks.rFcltDeptStat({
        searchInput,
        keywordType,
        year,
      })
    );
  }, [keywordType, searchInput, year, dispatch]);

  const { fclts, depts } = useSelector(
    (state: T.RootState) => state.fcltDept_static
  );

  const {
    fcltDeptStat: {
      faculties: fclts_stat,
      departments: depts_stat,
      total: total_stat,
    },
    status,
  } = useSelector((state: T.RootState) => state.creationFilter);

  let fcltOptions = fclts_stat.map((x) => (
    <Option className="sub-heading-font" value={x.id} key={x.id}>
      {`${fclts[x.id].name} (${x.count})`}
    </Option>
  ));

  // facultyID may not exist in the fclts_stat(when user switch between pub and rsr)
  if (facultyID !== -1 && !fclts_stat.find((x) => x.id === facultyID)) {
    fcltOptions.push(
      <Option className="sub-heading-font" value={facultyID} key={facultyID}>
        {`${fclts[facultyID].name} (0)`}
      </Option>
    );
  }

  fcltOptions = [
    <Option className="sub-heading-font" value={-1} key={-1}>
      {"All Faculties" + (total_stat >= 0 ? ` (${total_stat})` : "")}
    </Option>,
    ...fcltOptions,
  ];

  let deptOptions = depts_stat
    .filter((d) => facultyID === -1 || depts[d.id].facultyID === facultyID)
    .map((x) => (
      <Option className="sub-heading-font" value={x.id} key={x.id}>
        {`${depts[x.id].name} (${x.count})`}
      </Option>
    ));

  // we can not sum up the depts count directly
  // because a pub may belong to two departments simultaneously
  const total_Dept =
    facultyID === -1
      ? total_stat
      : fclts_stat.find((x) => x.id === facultyID)?.count;

  // deptID may not exist in the fclts_stat(when user switch between pub and rsr)
  if (departmentID !== -1 && !depts_stat.find((x) => x.id === departmentID)) {
    deptOptions.push(
      <Option
        className="sub-heading-font"
        value={departmentID}
        key={departmentID}
      >
        {`${depts[departmentID].name} (${0})`}
      </Option>
    );
  }

  deptOptions = [
    <Option className="sub-heading-font" value={-1} key={-1}>
      {"All Departments" +
        (total_Dept !== undefined && total_Dept >= 0 ? ` (${total_Dept})` : "")}
    </Option>,
    ...deptOptions,
  ];

  return (
    <>
      <Select
        className="sub-heading-font full-width"
        value={facultyID}
        style={{ marginBottom: 8 }}
        onChange={(value) => {
          dispatch(searchPageUserInputS.actions.setFacultyID(value));
        }}
        loading={status === "loading"}
        disabled={status === "loading"}
        showSearch={true}
        filterOption={(input, option) =>
          option !== undefined &&
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {fcltOptions}
      </Select>
      <Select
        className="sub-heading-font full-width"
        value={departmentID}
        style={{ marginBottom: 8 }}
        onChange={(value) => {
          dispatch(
            searchPageUserInputS.actions.setDepartmentID({
              deptID: value,
              fcltID: value !== -1 ? depts[value].facultyID : -1,
            })
          );
        }}
        loading={status === "loading"}
        disabled={status === "loading"}
        showSearch={true}
        filterOption={(input, option) =>
          option !== undefined &&
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {deptOptions}
      </Select>
    </>
  );
};
